import { InvoiceDetail } from '../components/invoice/InvoiceDetail';
import { AccessItems, AddAccessItem, EditAccessItem } from '../views/accessitem';
import { Dashboard } from '../views/dashboard';
import { InventoryList } from '../views/inventoryControl';
import EditClient from '../views/clients/Edit';
import AddClient from '../views/clients/Add';
import Clients from '../views/clients/Clients';
import { InvoiceList, InvoicePrint } from '../views/invoice';
import {
  AddOrderDelivery,
  OrderDeliveryList,
  OrderDeliveryListWithDetail,
} from '../views/orderDelivery';
import { AddExpressDelivery } from '../views/orderExpressDelivery';
import {
  AddOrderReturn,
  OrderReturnList,
  OrderReturnListWithDetail,
} from '../views/orderReturn/index';
import { OrderAdd, OrdersList, OrdersListWithDetail } from '../views/orders';
import { AddPermission, EditPermission, Permissions } from '../views/permission';
import { ProductEdit, ProductList, ProductListWithDetail } from '../views/product';
import ListLogs from '../views/product/ListLogs';
import ProductStep from '../views/product/ProductStep';
import GroupProductList from '../views/productGroup/List';
import GroupProductStep from '../views/productGroup/ProductStep';
import ProfilePage from '../views/profile';
import { DeliveryReport, OrderReport, ProductReport } from '../views/report';
import Request from '../views/request';
import { AddRole, EditRole, Roles } from '../views/role';
import { AddUser, EditUser, Users } from '../views/user';
import ModalAddSale from '../views/product/ModalAddSale';
import ModalEditSale from '../views/product/ModalEditSale';
import InventoryListWithDetail from '../views/inventoryControl/ListWithDetail/List';
import AddInventoryControl from '../views/inventoryControl/Add/Add';
import CreateBranch from '../views/profile/CreateBranch';
import BranchForm from '../views/profile/BranchForm';
import ProductGroupListWithDetail from '../views/productGroup/ListWithDetail';
import { ProductChanges, ProductChangesDetail } from '../views/productChange';

const dashboardRoutes = [
  {
    code: 'dashboard',
    path: '/dashboard',
    name: 'Хянах самбар',
    component: Dashboard,
  },
  {
    code: 'merchant-report',
    path: '/merchant-report',
    name: 'Тайлан',
    component: DeliveryReport,
  },
  {
    code: 'merchant-report/order-report',
    path: '/merchant-report/order-report',
    name: 'Захиалгын тайлан',
    component: OrderReport,
  },
  {
    code: 'merchant-report/product-report',
    path: '/merchant-report/product-report',
    name: 'Барааны тайлан',
    component: ProductReport,
  },
  {
    code: 'user',
    path: '/user',
    name: 'Системийн хэрэглэгч',
    component: Users,
    parent: 'settings',
  },
  {
    code: 'useradd',
    path: '/user/add',
    name: 'Системийн хэрэглэгч нэмэх',
    component: AddUser,
    parent: 'user',
  },
  {
    code: 'useredit',
    path: '/user/edit',
    name: 'Системийн хэрэглэгч засах',
    component: EditUser,
    parent: 'user',
  },

  {
    code: 'role',
    path: '/role',
    name: 'Роль',
    component: Roles,
    parent: 'settings',
  },
  {
    code: 'roleadd',
    path: '/role/add',
    name: 'Роль нэмэх',
    component: AddRole,
    parent: 'role',
  },
  {
    code: 'roleedit',
    path: '/role/edit',
    name: 'Роль засах',
    component: EditRole,
    parent: 'role',
  },

  {
    code: 'permission',
    path: '/permission',
    name: 'Өгөгдөлд хандах эрх',
    component: Permissions,
    parent: 'settings',
  },
  {
    code: 'permissionadd',
    path: '/permission/add',
    name: 'Өгөгдөлд хандах эрх нэмэх',
    component: AddPermission,
    parent: 'permission',
  },
  {
    code: 'permissionedit',
    path: '/permission/edit',
    name: 'Өгөгдөлд хандах эрх засах',
    component: EditPermission,
    parent: 'permission',
  },

  {
    code: 'accessitem',
    path: '/accessitem',
    name: 'Хандах элементүүд',
    component: AccessItems,
    parent: 'settings',
  },
  {
    code: 'accessitemadd',
    path: '/accessitem/add',
    name: 'Хандах элементүүд нэмэх',
    component: AddAccessItem,
    parent: 'accessitem',
  },
  {
    code: 'accessitemedit',
    path: '/accessitem/edit',
    name: 'Хандах элементүүд засах',
    component: EditAccessItem,
    parent: 'accessitem',
  },

  // {
  //   code: "profile",
  //   path: "/profile",
  //   name: "Профайл",
  //   component: ProfilePage,
  // },
  //Тооллого
  {
    code: 'merchant-inventory-control',
    path: '/merchant/inventory/control',
    name: 'Тооллого',
    component: InventoryList,
  },
  {
    code: 'merchant-inventory-control-with-detail',
    path: '/merchant/inventory/controls/:controlId',
    name: 'Тооллогын дэлгэрэнгүй',
    component: InventoryListWithDetail,
    parent: 'merchant-inventory-control',
  },
  {
    code: 'merchant-inventory-control-add',
    path: '/merchant/inventory/control/add',
    component: AddInventoryControl,
    parent: 'merchant-inventory-control',
  },
  //
  {
    code: 'merchant-order-pick-add',
    path: '/merchant/order/pick/add',
    name: 'Захиалга үүсгэх',
    component: OrderAdd,
    parent: 'merchant-order-pick',
  },
  {
    code: 'merchant-product-list',
    path: '/merchant/product/list',
    name: 'Нэгж бараа',
    component: ProductList,
    parent: 'merchant-product',
  },
  {
    code: 'merchant-product-list-with-detail',
    path: '/merchant/products/:productId',
    name: 'Нэгж бараа дэлгэрэнгүй',
    component: ProductListWithDetail,
    parent: 'merchant-product',
  },
  {
    path: '/merchant/product/list/logs',
    name: 'Барааны лог',
    component: ListLogs,
  },
  {
    code: 'product-add',
    path: '/product/add',
    name: 'Шинэ бараа үүсгэх',
    component: ProductStep,
    parent: 'merchant-product',
  },
  {
    code: 'product-edit',
    path: '/product/edit',
    name: 'Бараа засах',
    component: ProductEdit,
    parent: 'merchant-product',
  },
  {
    code: 'product-sale-edit',
    path: '/product/sale/edit',
    name: 'Хямдарсан үнэ засах',
    component: ModalEditSale,
    parent: 'merchant-product',
  },
  {
    code: 'product-sale-add',
    path: '/product/sale/add',
    name: 'Хямдарсан үнэ нэмэх',
    component: ModalAddSale,
    parent: 'merchant-product',
  },
  // group product
  {
    code: 'merchant-product-category',
    path: '/merchant/group/product/list',
    name: 'Багц бараа',
    component: GroupProductList,
    parent: 'merchant-product',
  },
  // {
  // 	code: "merchant-product-group-list-with-detail",
  // 	path: "/merchant/products/group:productId",
  // 	name: "Багц бараа дэлгэрэнгүй",
  // 	component: ProductListItem,
  // 	parent: "merchant-product"
  // },
  {
    code: 'merchant-product-group-list-with-detail',
    path: '/merchant/group/products/:productId',
    name: 'Багц бараа дэлгэрэнгүй',
    component: ProductGroupListWithDetail,
    parent: 'merchant-product',
  },
  {
    code: 'merchant-product-category-add',
    path: '/merchant/group/product/add',
    name: 'Багц бараа үүсгэх',
    component: GroupProductStep,
    parent: 'merchant-product',
  },

  //product change
  {
    code: 'product-changes',
    path: '/product-changes',
    name: 'Барааны өөрчлөлт',
    component: ProductChanges,
    parent: 'product-settings',
  },
  {
    code: 'product-changes-detail',
    path: '/product-changes/:changeId',
    name: 'Барааны өөрчлөлтийн дэлгэрэнгүй',
    component: ProductChangesDetail,
    parent: 'product-settings',
  },

  // merchant order
  {
    code: 'merchant-order-pick',
    path: '/merchant/order/pick',
    name: 'Татан авалт',
    component: OrdersList,
    parent: 'merchant-order',
  },
  {
    code: 'merchant-order-pick-with-detail',
    path: '/merchant/order/picks/:orderId',
    name: 'Татан авалт',
    component: OrdersListWithDetail,
    parent: 'merchant-order',
  },
  {
    code: 'merchant-order-delivery-add',
    path: '/order/delivery/add',
    name: 'Шинэ хүргэлтийн захиалга',
    component: AddOrderDelivery,
    parent: 'merchant-order-delivery',
  },
  {
    code: 'merchant-order-direct-delivery-add',
    path: '/order/direct-delivery/add',
    name: 'Шинэ хүргэлтийн захиалга',
    component: AddExpressDelivery,
    parent: 'merchant-order-delivery',
  },
  {
    code: 'merchant-order-delivery',
    path: '/merchant/order/delivery',
    name: 'Хүргэлтүүд',
    component: OrderDeliveryList,
    parent: 'merchant-order',
  },
  {
    code: 'merchant-order-delivery-with-detail',
    path: '/merchant/order/deliveries/:orderId',
    name: 'Хүргэлтүүд',
    component: OrderDeliveryListWithDetail,
    parent: 'merchant-order',
  },
  {
    code: 'merchant-order-return',
    path: '/merchant/order/return',
    name: 'Буцаалт',
    component: OrderReturnList,
    parent: 'merchant-order',
  },
  {
    code: 'merchant-order-return-with-detail',
    path: '/merchant/order/returns/:orderId',
    name: 'Буцаалт',
    component: OrderReturnListWithDetail,
    parent: 'merchant-order',
  },
  {
    code: 'merchant-order-return-add',
    path: '/order/return/add',
    name: 'Буцаалт',
    component: AddOrderReturn,
    parent: 'merchant-order-return',
  },

  {
    code: 'merchant-request',
    path: '/request',
    name: 'Бизнес нэмэх',
    component: Request,
  },

  {
    code: 'merchant-invoice',
    path: '/invoice-list',
    name: 'Нэхэмжлэхүүд',
    component: InvoiceList,
  },
  {
    code: 'merchant-invoice-desc',
    path: '/invoice-desc/:id',
    name: 'Нэхэмжлэхүүд',
    component: InvoiceDetail,
  },
  {
    code: 'merchant-invoice-print',
    path: '/invoice-print/:id',
    name: 'Нэхэмжлэхүүд',
    component: InvoicePrint,
  },
  {
    code: 'merchant-clients',
    path: '/clients',
    name: 'Харилцагчид',
    component: Clients,
  },
  {
    code: 'merchant-clients-add',
    path: '/clients/add',
    name: 'Харилцагч',
    component: AddClient,
  },
  {
    code: 'merchant-clients-edit',
    path: '/clients/edit',
    name: 'Харилцагч',
    component: EditClient,
  },

  {
    code: 'settings',
    path: '/settings',
    name: 'Тохиргоо',
    component: ProfilePage,
  },
  {
    code: 'settings',
    path: '/settings/branch/add',
    name: 'Салбар',
    component: CreateBranch,
  },
  {
    code: 'settings',
    path: '/settings/branch/edit',
    name: 'Салбар',
    component: BranchForm,
  },
];

export default dashboardRoutes;
